// extracted by mini-css-extract-plugin
export default {"butonatDiv":"Buton_butonatDiv__m1Avg","buttonat":"Buton_buttonat__N2EcI","butoniAddToCart":"Buton_butoniAddToCart__1Bs8Z"};